export default __webpack_public_path__ + "static/media/4.ce244474.png";